import { createRouter, createWebHistory } from 'vue-router'
import { isLoggedIn, isDisposalOwner, clearLoginSession } from '@/utils/auth'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/Index.vue'),
    meta: {
      title: '登录',
      public: true
    }
  },
  {
    path: '/disposal-center',
    name: 'DisposalCenter',
    component: () => import('@/views/DisposalCenter/Index.vue'),
    meta: {
      title: '处置中心'
    }
  },
  {
    path: '/disposal-center/detail/:id',
    name: 'DisposalOrderDetail',
    component: () => import('@/components/disposal/orderdetail.vue'),
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/disposal-records',
    name: 'DisposalRecords',
    component: () => import('@/views/DisposalRecords/Index.vue'),
    meta: {
      title: '处置记录'
    }
  },
  {
    path: '/finance',
    name: 'Finance',
    component: () => import('@/views/Finance/Index.vue'),
    meta: {
      title: '财务统计'
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/Profile/Index.vue'),
    meta: {
      title: '个人中心'
    }
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} - 装修垃圾清运处置端`
  }

  const loggedIn = isLoggedIn()

  if (to.path === '/login') {
    if (loggedIn) {
      next('/disposal-center')
    } else {
      next()
    }
    return
  }

  if (!to.meta.public && !loggedIn) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }

  if (loggedIn && !to.meta.public && !isDisposalOwner()) {
    clearLoginSession()
    next({ path: '/login', query: { redirect: to.fullPath, error: 'owner_only' } })
    return
  }

  next()
})

export default router
